import { apiSlice } from "../api/apiSlice";

export const teamApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: (email) => `/teams?members_like=-${email}`,
      invalidatesTags: ["addMember"],
    }),
    getTeam: builder.query({
      query: (id) => `/teams/${id}`,
      keepUnusedDataFor: 0.5,
    }),
    createTeam: builder.mutation({
      query: (data) => ({
        url: "/teams",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const team = await queryFulfilled;
        if (team) {
          dispatch(
            apiSlice.util.updateQueryData(
              "getTeams",
              team?.data?.owner,
              (draft) => {
                draft.push(team?.data);
              }
            )
          );
        }
      },
    }),
    addMember: builder.mutation({
      query: ({ id, data }) => ({
        url: `/teams/${id}`,
        method: "PUT",
        body: data,
        invalidatesTags: ["addMember"],
      }),
    }),
  }),
});

export const {
  useCreateTeamMutation,
  useGetTeamsQuery,
  useAddMemberMutation,
  useGetTeamQuery,
} = teamApi;
